<template>
  <page-content>
    <edit-field-header
      :title="title"
      @routerBack="$router.back()"
    />

    <edit-field
      ref="edit_field"
      :is-edit="true"
      :fields="fields"
      :row-data="row_data"
      post-api="/memberface/EditFaceCollection"
      :submitAction="submitAction"
      finish-router="kioskMemberFaceId_ManageCollectionId"
      permission="Kiosk_CollectionID_Edit"
      @beforeSubmit="beforeSubmit"
    >
      <template #facility="scope">
        <SlotFacility
          :row-data="scope.rowData" :company-id="scope.rowData.companyID"
          :facility-id="scope.rowData.facilityID" :is-edit="scope.isEdit" :disabled="scope.rootItem.edit_disable"
        />
      </template>

      <template #floor="scope">
        <SlotFloor :row-data="scope.rowData" :facility-id="scope.rowData.facilityID"
                   :disabled="scope.rootItem.edit_disable"
        />
      </template>

      <template #room="scope">
        <SlotRoom :row-data="scope.rowData" :floor-id="scope.rowData.floorID" :disabled="scope.rootItem.edit_disable"/>
      </template>

      <template #bed="scope">
        <SlotBed :row-data="scope.rowData" :room-id="scope.rowData.roomID" :disabled="scope.rootItem.edit_disable"/>
      </template>

      <template #photo="scope">
        <SlotPhoto ref="photo" :row-data="scope.rowData" :is-edit="scope.isEdit"
                   :disabled="scope.rootItem.edit_disable"
        />
      </template>

      <template v-slot:inputs="scope">
        <slot-inputs
          ref="slot_inputs"
          :root-item="scope.rootItem"
          :items="row_data['collectionIDs']"
          @updateValues="(value) => row_data['collectionIDs'] = value"
        />
      </template>
    </edit-field>
  </page-content>
</template>

<script>
import fields from './fields'
import EditField from '@/components/EditField2.vue'
import EditFieldHeader from '@/components/EditFieldHeader.vue'
import common from '@/common'
import PageContent from '@/components/PageContent.vue'
import SlotFacility from '@/views/member/SlotFacility.vue'
import SlotFloor from '@/views/member/SlotFloor.vue'
import SlotRoom from '@/views/member/SlotRoom.vue'
import SlotBed from '@/views/member/SlotBed.vue'
import SlotPhoto from '@/views/member/SlotPhoto.vue'
import SlotInputs from '@/components/FieldInputs.vue'
import _ from 'lodash'

export default {
  name: 'Edit',
  components: {
    SlotPhoto,
    SlotBed,
    SlotRoom,
    SlotFloor,
    SlotFacility,
    SlotInputs,
    PageContent,
    EditFieldHeader,
    EditField,
    fields,
  },
  data() {
    return {
      title: this.$t('kiosk.collection_id_management') + ' - ' + common.getI18n('common.edit'),
      id: this.$router.currentRoute.params.id,
      fields,
      row_data: {}
    }
  },
  mounted() {
    this.id = common.decrypt(this.id)
    if (this.id === undefined) {
      this.$router.replace({ path: '/' + this.$route.path.split('/')[1] })
      return false
    }
    common.apiGetData('/memberface/GetFaceCollection?facilityID=' + this.id)
      .then(res => {
        this.row_data = res.data.facilityFace
      })
  },
  methods: {
    beforeSubmit(callback) {
      const rowData = JSON.parse(JSON.stringify(this.$refs.edit_field.rowData));
      ['birthDate', 'joinedDate'].forEach((key) => {
        if (![null, undefined].includes(rowData[key]) && isNaN(Date.parse(rowData[key]))) {
          rowData[key] = null
        }
      })
      callback(true, {
        memberID: rowData.memberID,
        nfcTags: rowData.nfcTags,
      })
    },
    submitAction(rowData, api, finishRouter) {
      this.$requestWehealth({
        method: 'post',
        url: api,
        data: rowData
      })
        .then(res => {
          this.$router.push({ name: finishRouter })
        })
    }
  }
}
</script>

<style scoped>

</style>
